export { default } from './ErrorBoundary';
export type { ErrorBoundaryProps, ErrorBoundaryClassKey, ErrorBoundaryClasses } from './ErrorBoundary.types';
